import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import { BsArrowRight } from "react-icons/bs";
import Box from "@mui/material/Box";
import { motion } from "framer-motion";
import "./homePageModal.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const HomePageModal = ({
  Iindex,
  iTitle,
  iDocPath,
  iLink,
  iZoom,
  skipAll,
  onClose,
}) => {
  const [open, setOpen] = useState(true);
  const [imageLoading, setLoading] = useState(true);

  const handleClose = () => {
    if (open) {
      setOpen(false);
      // Inform parent that this modal closed
      onClose && onClose();
    }
  };

  const onLoaded = () => {
    setLoading(false);
  };

  // If skipAll becomes true, close this modal
  useEffect(() => {
    if (skipAll && open) {
      handleClose();
    }
  }, [skipAll]);

  if (!open) {
    return null;
  }

  return (
    <BootstrapDialog
      style={{ zIndex: `${999 - Iindex}` }}
      onClose={handleClose}
      scroll="paper"
      TransitionComponent={Transition}
      aria-labelledby="customized-dialog-title"
      aria-describedby="customized-dialog-description"
      open={open}
    >
      <DialogContent id="HomepageModalCustomScroll" dividers="paper">
        <Box>
          <h2
            id="customized-dialog-title"
            style={{
              position: "absolute",
              width: "1px",
              height: "1px",
              padding: 0,
              margin: "-1px",
              overflow: "hidden",
              clip: "rect(0, 0, 0, 0)",
              whiteSpace: "nowrap",
              border: 0,
            }}
          >
            {iTitle || "Announcement"}
          </h2>
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "8px",
              zIndex: "999",
            }}
          >
            <button
              type="button"
              className="HomepageModalCloseButtonContainer"
              onClick={handleClose}
              aria-label="Skip this announcement"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "0 3px",
                cursor: "pointer",
                background: "transparent",
                border: "none",
                color: "#fff",
                padding: 0,
              }}
            >
              <p>Skip</p>
              <BsArrowRight
                aria-hidden="true"
                focusable="false"
                style={{
                  color: "#fff",
                  fontSize: "16px",
                  strokeWidth: "0.5px",
                }}
              />
            </button>
          </div>

          <a
            href={iDocPath}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={iTitle || "Open announcement"}
          >
            <motion.img
              initial={{ opacity: 0 }}
              animate={{
                opacity: imageLoading ? 0 : 1,
              }}
              transition={{ opacity: { delay: 0.5, duration: 0.4 } }}
              loading="lazy"
              onLoad={onLoaded}
              className="HomePageModalImage"
              alt={iTitle || "Announcement"}
              src={iDocPath}
            />
            <span className="a11y-sr-only"> (opens in new window)</span>
          </a>
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
};

HomePageModal.propTypes = {
  Iindex: PropTypes.number,
  iTitle: PropTypes.string,
  iDocPath: PropTypes.string.isRequired,
  iLink: PropTypes.string,
  iZoom: PropTypes.any,
  skipAll: PropTypes.bool,
  onClose: PropTypes.func,
};

export default HomePageModal;
